// Vipps payment return for the Android/iOS app. Inside the app the page's own
// origin is https://localhost / capacitor://localhost, which the phone can't
// open after Vipps. Android returns to the real domain and opens the app for
// that link (App Link). iOS ends the payment in Safari, which never hands an
// https link it is redirected to over to the app (Universal Links only work on
// a tap) - so the iPhone app returns through its own URL scheme (Info.plist).
const APP_HOST = "app.playworld.no";
const IOS_SCHEME = "no.playworld.app";

// platform: Capacitor.getPlatform() - "ios", "android" or "web".
export function paymentReturnUrl(platform, origin) {
  if (platform === "ios") return `${IOS_SCHEME}://${APP_HOST}/PaymentReturn`;
  return `${platform === "android" ? `https://${APP_HOST}` : origin}/PaymentReturn`;
}

// Route inside the app for a link the phone opened the app with, or null for
// links the app doesn't handle (only the payment return opens the app).
export function appLinkRoute(url) {
  let parsed;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  if (parsed.host !== APP_HOST || parsed.pathname.toLowerCase() !== "/paymentreturn") return null;
  return `/paymentreturn${parsed.search}`;
}

// iOS getLaunchUrl returns the last link the app was opened with, for as long
// as the app runs - so the header's reload button would land on the payment
// return page again. sessionStorage survives a reload but not an app restart.
export function launchUrlNotYetHandled() {
  if (sessionStorage.getItem("launchUrlHandled")) return false;
  sessionStorage.setItem("launchUrlHandled", "1");
  return true;
}
